import { useCallback, useEffect } from 'react';

export function useDebounceEffect(fn, wait = 0, deps = []) {
  const callback = useCallback(fn, deps);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      callback();
    }, wait);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [callback, wait]);
}
